import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";

import { Router } from "@angular/router";
import { ROUTE_URL } from "../../constants/routes";
import { CommonService } from "@services/common.service";
import { CanvasService } from "@services/canvas.service";
@Component({
    selector: "app-application-list",
    templateUrl: "./application-list.component.html",
    styleUrls: ["./application-list.component.scss"],
    standalone: false
})
export class ApplicationListComponent implements OnInit, OnChanges {
  constructor(
    private router: Router,
    public commonService: CommonService,
    public canvasService: CanvasService
  ) {}

  loading = true;
  applications: any[] = [];

  getUserCategories() {
    this.commonService.getUserCategories().subscribe((data: any) => {
      const userCategories = data.data;
      this.applications = data.data;

      this.loadApplications();
    });
  }

  gotoDashboard(id: any) {
    this.router.navigate([ROUTE_URL.viewDashboardAppURL, id]);
    // window.location.href = ROUTE_URL.viewDashboardAppURL + "/" + id;
  }

  loadApplications() {
    this.applications = this.applications.filter(function (app: any) {
      return app.dashboardId != null;
    });
    this.loading = false;
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.getUserCategories();
  }
  ngOnInit(): void {
    this.getUserCategories();
  }
}
